import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberProfilePage from "@/pages/member/MemberProfilePage";

export const Route = createFileRoute("/member/profile")({
  head: () => pageHead("Member · Profile", "AKIVA member · profile portal.", "/member/profile", true),
  component: MemberProfilePage,
});
